import "./moduleInformation.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";

import React from "react";

import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
// import { useSelector } from "react-redux";
// import { panelInformation } from "../Design&Structure/structureFunction";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

function tableRender(tableData) {
  return (
    <div className="render-function">
      <table className="render-table">
        <thead>
          <tr>
            <td>Property</td>
            <td>Value</td>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => {
            return (
              <tr key={index} className={index % 2 === 0 ? "one" : "two"}>
                <td className="left">{item.title}</td>
                <td className="right">{item.value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function chartBallText(data) {
  return (
    <>
      {data.map((item, index) => {
        return (
          <div key={index} className="chart-ball-text">
            <div
              className="ball"
              style={{
                backgroundColor: item.borderColor,
                height: "15px",
                width: "15px",
                borderRadius: "50%",
              }}
            ></div>
            <p>{item.label}</p>
          </div>
        );
      })}
    </>
  );
}

const ModuleInformation = (props) => {
  const { tableContent } = props;

  let arr = [
    98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98,
    98, 98, 98, 98, 98, 98, 98,
  ];
  let arr2 = arr;
  arr = arr.map((item, i) => item - 0.55 * i);

  arr2 = arr2.map((item, i) => item - 0.6 * i);

  let moduleConfiguration = [
    {
      title: "Performance Curve",
      value: "Linear",
    },
    {
      title: "Yearly degradation",
      value: "0.55%",
    },
    {
      title: "Power output after 1 Year",
      value: `${arr[1]}%`,
    },
    {
      title: "Power output after 25 years",
      value: `${arr[25]}%`,
    },
  ];

  let options = {
    responsive: false,
    plugins: {
      tooltip: {
        enabled: false, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 11,
          },
          display: true,
          text: "Time in Years", // X-axis title
        },
        grid: {
          drawOnChartArea: false, // Extended vertical lines below x-axis only
        },
      },
      y: {
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        // beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: "Remaining output in %", // Y-axis title
        },
        grid: {
          display: true, // Show horizontal grid lines
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  let state = {
    data: {
      // Add labels till 16
      labels: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
      ],
      datasets: [
        {
          label: "PV Generated Energy",
          backgroundColor: (context) => {
            if (!context.chart.chartArea) return;
            const {
              ctx,
              chartArea: { top, bottom },
            } = context.chart;
            const gradientBackground = ctx.createLinearGradient(
              0,
              top,
              0,
              bottom
            );
            gradientBackground.addColorStop(0, "rgba(4, 80, 151, 0.45)");
            gradientBackground.addColorStop(0.5, "rgba(4, 80, 151, 0.1)");
            gradientBackground.addColorStop(0.9, "rgba(4, 80, 151, 0)");

            return gradientBackground;
          },
          borderColor: "#045097",
          data: arr,
          fill: true,
          tension: 0.4,
          pointRadius: 0,
        },
        {
          label: "Energy from the Grid",
          backgroundColor: (context) => {
            if (!context.chart.chartArea) return;
            const {
              ctx,
              chartArea: { top, bottom },
            } = context.chart;
            const gradientBackground = ctx.createLinearGradient(
              0,
              top,
              0,
              bottom
            );
            gradientBackground.addColorStop(0, "rgba(122, 204, 249, 0.45)");
            gradientBackground.addColorStop(0.5, "rgba(122, 204, 249, 0.1)");
            gradientBackground.addColorStop(0.9, "rgba(122, 204, 249, 0)");

            return gradientBackground;
          },
          borderColor: "#7ACCF9",
          data: arr2,
          fill: true,
          tension: 0.4,
          pointRadius: 0,
        },
      ],
    },
  };

  const pageDetail = tableContent.find(
    (item) => item.title === "PV Module Details"
  );

  return (
    <div id="module-information" className="module-information">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="mi-body">
        <p>PV Module Details</p>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender(moduleConfiguration)}
        </div>

        <p style={{ marginTop: "30px", marginBottom: "20px" }}>
          PV Module Degradation
        </p>
        <Line
          height="315px"
          width="495px"
          options={options}
          data={state.data}
        />
        <div className="chart-ball-text-container">
          {chartBallText(state.data.datasets)}
        </div>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default ModuleInformation;
